import { SystemUserLabels } from 'client/systemusers/constants/SystemUserConstants';
import moment from 'moment';

const SystemUserFilters = {
  activated: bool => ({
    displayValue: SystemUserLabels.pending,
    name: 'activated',
    operator: 'eq',
    value: bool,
    type: 'status',
  }),
  externallyManaged: bool => ({
    displayValue: SystemUserLabels.externallyManaged,
    name: 'externally_managed',
    operator: 'eq',
    value: bool,
    type: 'status',
  }),
  ldap: bool => ({
    displayValue: SystemUserLabels.ldap,
    name: 'ldap_binding_user',
    operator: 'eq',
    value: bool,
    type: 'permissions',
  }),
  locked: bool => ({
    // Type and displayValue are used in filter pill display. (type : displayValue)
    name: 'account_locked',
    operator: 'eq',
    value: bool,
    type: 'status',
    displayValue: SystemUserLabels.accountLocked,
  }),
  noPassword: bool => ({
    displayValue: SystemUserLabels.noPassword,
    name: 'activated',
    operator: '$ne',
    value: bool,
    type: 'status',
  }),
  passwordExpired: bool => ({
    displayValue: SystemUserLabels.passwordExpired,
    name: 'password_expired',
    operator: 'eq',
    value: bool,
    type: 'status',
  }),
  passwordExpiring: numDays => ([
    {
      displayValue: SystemUserLabels.passwordExpiring(14),
      field: 'password_expiration_date',
      name: 'passwordExpiring',
      operator: '$gte',
      value: moment().format('YYYY-MM-DD'),
      type: 'status',
    }, {
      displayValue: SystemUserLabels.passwordExpiring(14),
      field: 'password_expiration_date',
      name: 'passwordExpiring',
      operator: '$lte',
      value: moment().add(numDays, 'days').format('YYYY-MM-DD'),
      type: 'status',
    }, {
      displayValue: SystemUserLabels.passwordExpiring(14),
      field: 'password_expired',
      name: 'passwordExpiring',
      operator: 'eq',
      value: false,
      type: 'status',
    },
  ]),
  created: numDays => ({
    /*
     Type and displayValue are used in filter pill display. (type : displayValue)
    */
    name: 'created',
    field: 'created',
    operator: '$gte',
    value: numDays.toISOString().slice(0, 10),
    type: 'status',
    displayValue: 'created',
  }),
  createdOnOrBefore: date => ({
    name: 'created',
    field: 'created',
    operator: '$lte',
    value: date.format('YYYY-MM-DD'),
    type: 'status',
  }),
  sudo: bool => ({
    displayValue: SystemUserLabels.globalAdminSudo,
    name: 'sudo',
    operator: 'eq',
    value: bool,
    type: 'permissions',
  }),
  sudoPasswordLess: bool => ({
    displayValue: SystemUserLabels.globalAdminPasswordless,
    name: 'passwordless_sudo',
    operator: 'eq',
    value: bool,
    type: 'permissions',
  }),
  sambaAccess: bool => ({
    displayValue: SystemUserLabels.sambaAccess,
    name: 'samba_service_user',
    operator: 'eq',
    value: bool,
    type: 'permissions',
  }),
  mfaEnrolled: bool => ({
    displayValue: bool ? 'enrolled' : 'not enrolled',
    name: 'mfaEnrollment.overallStatus',
    operator: 'eq',
    value: bool ? 'ENROLLED' : 'NOT_ENROLLED',
    type: 'MFA enrollment status',
  }),
  mfaEnabled: bool => ({
    displayValue: bool ? 'required' : 'not required',
    name: 'enable_user_portal_multifactor',
    operator: 'eq',
    value: bool,
    type: 'MFA user req',
  }),
  totpEnabled: bool => ({
    displayValue: bool ? 'active' : 'inactive',
    name: 'totp_enabled',
    operator: 'eq',
    value: bool,
    type: 'MFA Status',
  }),
  userSuspended: bool => ({
    displayValue: SystemUserLabels.userSuspended,
    name: 'suspended',
    operator: 'eq',
    value: bool,
    type: 'status',
  }),
};

export default SystemUserFilters;
